import './DateInput.scss';

import { DatePicker } from '@mui/x-date-pickers';
import classNames from 'classnames';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

export function DateInput({
  value,
  onChange,
  className,
  minDate,
  maxDate,
  disableValues,
  placeholder = 'mm/dd/yyyy',
  variant = 'white',
  readOnly,
}) {
  return (
    <div className={classNames(className)}>
      <DatePicker
        className={classNames(
          readOnly && 'date-picker-disabled',
          `date-picker date-picker--${variant}`,
        )}
        shouldDisableDate={disableValues}
        minDate={minDate ? dayjs(minDate) : ''}
        maxDate={maxDate ? dayjs(maxDate) : ''}
        value={value ? dayjs(value) : null}
        onKeyDown={(e) => e.preventDefault}
        slotProps={{ textField: { placeholder } }}
        readOnly={readOnly}
        onChange={(date) =>
          onChange(date ? dayjs(date).format('YYYY-MM-DD') : null)
        }
      />
    </div>
  );
}

DateInput.propTypes = {
  value: PropTypes.string || PropTypes.instanceOf(Date) || PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  disableValues: PropTypes.bool,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
};
